export const getStoredUsername = () => localStorage.getItem('username') || '';
export const setStoredUsername = (u) => u ? localStorage.setItem('username', u) : localStorage.removeItem('username');
export const setStoredUserId = (id) => id ? localStorage.setItem('userId', String(id)) : localStorage.removeItem('userId');

const API_BASE = '/api/v1';

export class ApiError extends Error {
    constructor(status, message) {
        super(message);
        this.name = 'ApiError';
        this.status = status;
    }
}

export function isAuthError(err) {
    return err instanceof ApiError && err.status === 401;
}

const FRIENDLY_MESSAGES = {
    400: 'Invalid request. Please check your input.',
    403: 'You don\u2019t have permission to do that.',
    404: 'The item you\u2019re looking for no longer exists.',
    409: 'This conflicts with an existing item.',
    500: 'Something went wrong on the server. Please try again.',
    502: 'Server is temporarily unavailable. Please try again.',
    503: 'Server is temporarily unavailable. Please try again.',
};

async function parseServerHint(res) {
    try {
        const text = await res.text();
        if (!text) return null;
        if (text.includes('ECONNREFUSED') || text.includes('Proxy error'))
            return 'Server is unreachable. Please try again later.';
        try {
            const data = JSON.parse(text);
            if (data.error) return data.error;
        } catch {}
        return null;
    } catch {
        return null;
    }
}

function friendlyMessage(status, serverHint) {
    if (serverHint) return serverHint;
    return FRIENDLY_MESSAGES[status] || 'Something went wrong. Please try again.';
}

export async function apiFetch(url, options = {}) {
    let res;
    try {
        res = await fetch(API_BASE + url, {
            ...options,
            credentials: 'same-origin',
        });
    } catch (err) {
        if (err.name === 'AbortError') throw err;
        throw new ApiError(0, 'Network error. Check your connection and try again.');
    }
    if (res.status === 401) {
        window.dispatchEvent(new Event('auth:logout'));
        throw new ApiError(401, 'Session expired');
    }
    if (!res.ok) {
        const serverHint = await parseServerHint(res);
        throw new ApiError(res.status, friendlyMessage(res.status, serverHint));
    }
    return res;
}

export async function fetchProfile() {
    const res = await apiFetch('/users/me');
    return res.json();
}

export async function updateProfile(displayName) {
    const res = await apiFetch('/users/me', {
        method: 'PATCH',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({displayName}),
    });
    return res.json();
}

export async function changePassword(currentPassword, newPassword) {
    const res = await apiFetch('/users/me/change-password', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({currentPassword, newPassword}),
    });
    return res.json();
}
